import React from 'react';
import PropTypes from 'prop-types';
import Button from '@fountain/ui-kit/components/button';
import Close from '../../../../../../../../app/assets/images/shared/x-icon.svg';

const FilterModal = ({ children, handleClose, handleSubmit }) => (
  <div className="filters-modal">
    <div className="filters-modal-nav">
      <h1 className="dsp-mobile__filter-title" >Filters</h1>
      <button className="dsp-mobile__filter-close-button" onClick={handleClose}>
        <img src={Close} alt="close" />
      </button>
    </div>
    {children}
    <Button onClick={handleSubmit} className="openings-table__body-button dsp-mobile__filter-apply">Apply Filter</Button>
  </div>);


FilterModal.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default FilterModal;
